module.exports = __webpack_public_path__ + "img/card-serviceplaces-hover.0501e643.svg";